import { IconButton } from "@mui/material";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useCallback } from "react";

import './header-chat.component.css';

export const HeaderChatComponent: React.FC = () => {
  const startNewThread = useCallback(() => {
    localStorage.removeItem("messages");
    localStorage.removeItem("threadId");
    localStorage.removeItem("chatInitied");
    window.location.reload();
  }, []);

  return (
    <div className="flex items-center bg-white inset-x-0 top-0 shadow-xl p-4">
      <div className="flex flex-row flex-1 justify-center items-center">
        <img src="https://ciandt.com/themes/custom/ciandt_theme/logo.svg" className="logo-cit" alt='CI&T' />         
      </div>
      <IconButton onClick={startNewThread} aria-label="Resetar o chat">
        <CloseIcon fontSize="inherit" />
      </IconButton>
    </div>
  );
};
